import {Component, Inject, LOCALE_ID, OnInit, ViewEncapsulation} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {SubSink} from "@Common/core/utils/subsink";
import {UntypedFormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import {Bel, belControls, BelState} from "../../../common/services/bel/bel/bel.model";
import {BelService} from "../../../common/services/bel/bel/bel.service";
import {finalize} from "rxjs/operators";
import {SnackBarToastyService, typeToast} from "@Common/widgets/general/snack-bar";
import {PubSubService} from "@Common/core/services";
import {AttachmentModel} from "@Common/widgets/general/attachments/interfaces/attachment.model";
import * as FileSaver from "file-saver";

@Component({
  selector: 'app-bel-edit',
  templateUrl: './bel-edit.component.html',
  styleUrls: ['./../style/bel.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class BelEditComponent implements OnInit {

  title = 'Nouveau bordereau d\'élimination';
  iconTitle = 'add';
  SubSink = new SubSink();
  belForm: UntypedFormGroup;
  Bel: Bel = {id:0, observations: null, state: BelState.CONSTITUTION_REVISION, label: null, documents_obj: []} as Bel;
  refresh_list = false;

  constructor(@Inject(LOCALE_ID) private locale: string,
              private router: Router,
              private route: ActivatedRoute,
              public belSvc: BelService,
              private formBuilder: UntypedFormBuilder,
              private snackSvc: SnackBarToastyService,
              private pubSubSvc: PubSubService,) {
    this._initBelForm();
  }

  ngOnInit(): void {
    this._getOrInitBel();
  }

  goList(): void {
    this.router.navigate(['gestion'], { queryParams: { tab: "eliminations"}});
  }

  saveBel(): void {
    this.updateObjectFromControl(this.Bel, belControls, this.belForm);
      this.pubSubSvc.publish('loading', true);
      this.SubSink.sink = this.belSvc.updateOrcreate(this.Bel).pipe(
        (finalize(()=> this.pubSubSvc.publish('loading', false)))
     ).subscribe( _data => {
        this.Bel = _data;
        this.belForm.markAsPristine();
        this.snackSvc.toasty('BEL', 'Le BEL a bien été enregistré', typeToast.success);
      }
    );
  }

  handleBelUploaded(pieceJ: AttachmentModel) {
    if (pieceJ) {
      this.Bel.bordereau_elimination_object = pieceJ;
      this.Bel.bordereau_elimination = pieceJ.id;
      this._updateProjetFile('Bordereau d\'élimination');
    }
  }

  handleBddUploaded(pieceJ: AttachmentModel) {
    if (pieceJ) {
      this.Bel.bordereau_destruction_object = pieceJ;
      this.Bel.bordereau_destruction = pieceJ.id;
      this._updateProjetFile('Bordereau de destruction');
    }
  }

  private _updateProjetFile(title: string) {
    if (this.Bel.id) {
      this.pubSubSvc.publish('loading', true);
      this.SubSink.sink = this.belSvc.update(this.Bel)
        .pipe(finalize(() => this.pubSubSvc.publish('loading', false)))
        .subscribe(() => {
          this.snackSvc.toasty(title, `${title} bien pris en compte`, typeToast.success);
        });
    }
  }

  private _getOrInitBel(): void {
    const id = this.route.snapshot.params['id'];
    if(id && id !== 0){
      this.SubSink.sink = this.belSvc.get(id).subscribe((_bel) => {
        this.Bel = _bel;
        this._populateBelForm(_bel);
        this.title = `Edition du BEL: ${this.Bel.label} (${this.Bel.reference})`;
        this.iconTitle = 'edit';
      });

    }
  }

  private _initBelForm() {
    this.belForm = this.formBuilder.group({
      label: [null, [Validators.required]],
      state: [BelState.CONSTITUTION_REVISION, [Validators.required]],
      observations: [null,[]],
      documents: [[],[]],
    });
  }

  /**
   * @param Bel
   * @private
   */
  private _populateBelForm(Bel: Bel): void {
    this.belForm.patchValue({
      label: Bel.label,
      state: Bel.state,
      observations: Bel.observations,
      documents: Bel.documents_obj,
    });
  }

  /**
   * TODO à mutualiser dans common archives voire dans le common général...
   * @param container
   * @param containerControls
   * @param formControl
   * @private
   */
  private updateObjectFromControl(container: {}, containerControls: [string, string][], formControl) {
    containerControls
      .forEach(([attribute, control]) => container[attribute] = formControl.controls[control].value);
  }

  exportPdfBel() {
    this.SubSink.sink = this.belSvc.exportBelPdf(this.Bel).subscribe(
      (_data) => FileSaver.saveAs(_data, `${this.Bel.reference}.pdf`)
    )
  }

  refreshEvent(refresh_signal: boolean): void {
    this.refresh_list = refresh_signal;
  }
}
